// Static conference data for "Reliance Foundation Building Flourishing Futures Conference"
// Used as fallback when API is unavailable

export const conferenceInfo = {
  title: "Reliance Foundation Building Flourishing Futures Conference",
  subtitle:
    "Meeting Learners Where They Are: From Early Childhood to Primary Education",
  dates: "7-8th February 2026",
  venue: "Nita Mukesh Ambani Junior School (NMAJS)",
};

export const staticSessions = {
  day1: [
    {
      id: "reg-day1",
      title: "Registration",
      description: "Conference registration and welcome",
      session_type: "networking",
      start_time: "2026-02-07T08:30:00",
      end_time: "2026-02-07T09:00:00",
      location: "Main Entrance",
      speakers: [],
      day: 1,
    },
    {
      id: "inaugural-day1",
      title: "Inaugural Session",
      description: "Ganesh Vandana, Lamp Lighting, and Welcome",
      session_type: "keynote",
      start_time: "2026-02-07T09:00:00",
      end_time: "2026-02-07T09:15:00",
      location: "Main Auditorium",
      speakers: [],
      day: 1,
      is_featured: true,
    },
    {
      id: "inaugural-address-day1",
      title: "Inaugural Address",
      description: "Opening remarks and conference overview",
      session_type: "keynote",
      start_time: "2026-02-07T09:15:00",
      end_time: "2026-02-07T09:30:00",
      location: "Main Auditorium",
      speakers: [],
      day: 1,
      is_featured: true,
    },
    {
      id: "keynote1-day1",
      title:
        "The Art of Talking With Children: Rich Conversations That Build Every Capacity",
      description:
        "Keynote presentation on effective communication strategies with children",
      session_type: "keynote",
      start_time: "2026-02-07T09:30:00",
      end_time: "2026-02-07T10:30:00",
      location: "Main Auditorium",
      speakers: [{ name: "Rebecca Rolland", title: "Harvard University" }],
      day: 1,
      is_featured: true,
    },
    {
      id: "panel1-day1",
      title:
        "Unlocking System Strength: Policy Pathways for Early Childhood and Foundational Learning",
      description:
        "Panel discussion on policy frameworks for early childhood education",
      session_type: "panel",
      start_time: "2026-02-07T10:30:00",
      end_time: "2026-02-07T11:10:00",
      location: "Main Auditorium",
      speakers: [
        {
          name: "Dr. Vanita Sharma",
          title:
            "Advisor, Strategic Initiatives, Reliance Foundation (Moderator)",
        },
        {
          name: "Dr Dhir Jhingran",
          title:
            "Founder and Executive Director, Language and Learning Foundation",
        },
      ],
      day: 1,
    },
    {
      id: "publication-launch-day1",
      title: "Publication Launch: RF Compendium on Play-Based Learning",
      description:
        "Launch of Reliance Foundation's comprehensive guide on play-based learning",
      session_type: "keynote",
      start_time: "2026-02-07T11:10:00",
      end_time: "2026-02-07T11:15:00",
      location: "Main Auditorium",
      speakers: [],
      day: 1,
    },
    {
      id: "tea-break-day1-1",
      title: "Tea Break",
      description: "Networking break with refreshments",
      session_type: "break",
      start_time: "2026-02-07T11:15:00",
      end_time: "2026-02-07T11:45:00",
      location: "Exhibition Zone",
      speakers: [],
      day: 1,
    },
    {
      id: "happy-school-day1",
      title: "Building a Happy School: A home away from home",
      description:
        "Creating inclusive environments that foster joy of learning",
      session_type: "talk",
      start_time: "2026-02-07T11:45:00",
      end_time: "2026-02-07T12:15:00",
      location: "Main Auditorium",
      speakers: [],
      day: 1,
    },
    {
      id: "panel2-day1",
      title: "Learning Through Play: Shaping the Early Years",
      description: "Expert panel on play-based learning methodologies",
      session_type: "panel",
      start_time: "2026-02-07T12:15:00",
      end_time: "2026-02-07T13:00:00",
      location: "Main Auditorium",
      speakers: [
        {
          name: "Monita Sen",
          title: "Head of Early Childhood, NMAJS (Moderator)",
        },
        {
          name: "Rita Chawla-Duggan",
          title: "Lecturer, Early Childhood Studies, Bath University, UK",
        },
        { name: "Kaushik S", title: "Program Head, ECCE, Reliance Foundation" },
        { name: "Prabhat Rai", title: "Senior Lecturer, Monash University" },
      ],
      day: 1,
    },
    {
      id: "voices-field-day1",
      title: "Voices from the Field: Anganwadi Learning Labs",
      description:
        "Insights from RF Anganwadi programme with video presentation",
      session_type: "talk",
      start_time: "2026-02-07T13:00:00",
      end_time: "2026-02-07T13:15:00",
      location: "Main Auditorium",
      speakers: [],
      day: 1,
    },
    {
      id: "lunch-day1",
      title: "Lunch",
      description: "Networking lunch",
      session_type: "break",
      start_time: "2026-02-07T13:15:00",
      end_time: "2026-02-07T14:15:00",
      location: "Dining Hall",
      speakers: [],
      day: 1,
    },
    {
      id: "learning-labs-day1",
      title: "Building Flourishing Futures Learning Labs",
      description:
        "15 interactive sessions across 3 streams: Foundations of Curiosity, Count/Read/Grow, and AI in Education. Participants will experience 4-5 curated stations.",
      session_type: "workshop",
      start_time: "2026-02-07T14:15:00",
      end_time: "2026-02-07T15:45:00",
      location: "Multiple Venues",
      speakers: [],
      day: 1,
      is_featured: true,
    },
    {
      id: "keynote2-day1",
      title:
        "Imagination, play and meeting the learner: The key role of the teacher",
      description:
        "Conceptual PlayWorld methodology across different cultural age periods",
      session_type: "keynote",
      start_time: "2026-02-07T15:45:00",
      end_time: "2026-02-07T16:45:00",
      location: "Main Auditorium",
      speakers: [{ name: "Dr. Marilyn Fleer", title: "Monash University" }],
      day: 1,
      is_featured: true,
    },
    {
      id: "close-day1",
      title: "Close of Day 1",
      description: "Day 1 closing remarks",
      session_type: "keynote",
      start_time: "2026-02-07T16:45:00",
      end_time: "2026-02-07T17:00:00",
      location: "Main Auditorium",
      speakers: [],
      day: 1,
    },
    {
      id: "school-tours-day1",
      title: "EYC School Tours (Optional)",
      description: "Guided tours of early years facilities",
      session_type: "networking",
      start_time: "2026-02-07T17:00:00",
      end_time: "2026-02-07T18:00:00",
      location: "Campus",
      speakers: [],
      day: 1,
    },
    {
      id: "high-tea-day1",
      title: "High Tea and Networking",
      description: "Evening networking in the Exhibition Zone",
      session_type: "networking",
      start_time: "2026-02-07T17:00:00",
      end_time: "2026-02-07T19:00:00",
      location: "Exhibition Zone",
      speakers: [],
      day: 1,
    },
  ],
  day2: [
    {
      id: "networking-tea-day2",
      title: "Networking & Tea",
      description: "Morning networking with refreshments",
      session_type: "networking",
      start_time: "2026-02-08T08:30:00",
      end_time: "2026-02-08T09:00:00",
      location: "Exhibition Zone",
      speakers: [],
      day: 2,
    },
    {
      id: "reflections-day2",
      title: "Day 1 Reflections",
      description: "Key takeaways and energy-setting for Day 2",
      session_type: "keynote",
      start_time: "2026-02-08T09:00:00",
      end_time: "2026-02-08T09:10:00",
      location: "Main Auditorium",
      speakers: [],
      day: 2,
    },
    {
      id: "panel3-day2",
      title:
        "Strong Starts Matter: Driving Foundational Literacy and Numeracy at Scale",
      description: "Panel discussion on scaling FLN initiatives",
      session_type: "panel",
      start_time: "2026-02-08T09:10:00",
      end_time: "2026-02-08T10:10:00",
      location: "Main Auditorium",
      speakers: [
        {
          name: "Anthony Batchelor",
          title: "Head of Junior School, NMAJS (Moderator)",
        },
      ],
      day: 2,
      is_featured: true,
    },
    {
      id: "voices-fln-day2",
      title: "Voices from the Field: FLN - LiftEd",
      description: "Insights from RF LiftEd programme with video presentation",
      session_type: "talk",
      start_time: "2026-02-08T10:10:00",
      end_time: "2026-02-08T10:25:00",
      location: "Main Auditorium",
      speakers: [],
      day: 2,
    },
    {
      id: "panel4-day2",
      title: "Digital for the Youngest Learners: From Screen time to Smart Use",
      description: "Panel on responsible technology use in early education",
      session_type: "panel",
      start_time: "2026-02-08T10:25:00",
      end_time: "2026-02-08T11:05:00",
      location: "Main Auditorium",
      speakers: [
        {
          name: "Gouri Gupta",
          title: "Director, EdTech, Central Square Foundation (Moderator)",
        },
        { name: "Nina Bual", title: "Co-Founder, Cyberlite" },
      ],
      day: 2,
    },
    {
      id: "tea-break-day2",
      title: "Tea Break",
      description: "Networking break with refreshments",
      session_type: "break",
      start_time: "2026-02-08T11:05:00",
      end_time: "2026-02-08T11:30:00",
      location: "Exhibition Zone",
      speakers: [],
      day: 2,
    },
    {
      id: "masterclasses-r1-day2",
      title: "Building Flourishing Futures Masterclasses - Round 1",
      description: "6 parallel masterclasses plus 2 Anganwadi-only sessions",
      session_type: "workshop",
      start_time: "2026-02-08T11:30:00",
      end_time: "2026-02-08T13:00:00",
      location: "Multiple Venues",
      speakers: [],
      day: 2,
      is_featured: true,
    },
    {
      id: "lunch-day2",
      title: "Lunch",
      description: "Networking lunch",
      session_type: "break",
      start_time: "2026-02-08T13:00:00",
      end_time: "2026-02-08T14:00:00",
      location: "Dining Hall",
      speakers: [],
      day: 2,
    },
    {
      id: "masterclasses-r2-day2",
      title: "Building Flourishing Futures Masterclasses - Round 2",
      description: "6 parallel masterclasses plus 2 Anganwadi-only sessions",
      session_type: "workshop",
      start_time: "2026-02-08T14:00:00",
      end_time: "2026-02-08T15:30:00",
      location: "Multiple Venues",
      speakers: [],
      day: 2,
      is_featured: true,
    },
    {
      id: "panel5-day2",
      title:
        "Growing with Care: Building the Foundations of Social and Emotional Learning",
      description: "Panel on SEL in early childhood education",
      session_type: "panel",
      start_time: "2026-02-08T15:30:00",
      end_time: "2026-02-08T16:20:00",
      location: "Main Auditorium",
      speakers: [],
      day: 2,
    },
    {
      id: "closing-day2",
      title: "Closing Remarks",
      description: "Conference closing and final thoughts",
      session_type: "keynote",
      start_time: "2026-02-08T16:20:00",
      end_time: "2026-02-08T16:30:00",
      location: "Main Auditorium",
      speakers: [],
      day: 2,
    },
    {
      id: "high-tea-day2",
      title: "High Tea and Networking",
      description: "Closing networking in the Exhibition Zone",
      session_type: "networking",
      start_time: "2026-02-08T16:30:00",
      end_time: "2026-02-08T18:00:00",
      location: "Exhibition Zone",
      speakers: [],
      day: 2,
    },
    {
      id: "school-tours-day2",
      title: "EYC School Tours (Optional)",
      description: "Guided tours of early years facilities",
      session_type: "networking",
      start_time: "2026-02-08T16:30:00",
      end_time: "2026-02-08T17:30:00",
      location: "Campus",
      speakers: [],
      day: 2,
    },
  ],
};

export const staticMasterclasses = [
  {
    id: "mc-1",
    title:
      "Planning for meeting children where they are at through a Conceptual PlayWorld",
    description: "Interactive masterclass on Conceptual PlayWorld methodology",
    instructor: {
      name: "Marilyn Fleer",
      title: "Foundation Chair in Early Childhood Education, Monash University",
    },
    start_time: "2026-02-08T11:30:00",
    end_time: "2026-02-08T13:00:00",
    location: "Workshop Room A",
    capacity: 30,
    current_registrations: 0,
    prerequisites: "None",
    materials: "Notebook for exercises",
  },
  {
    id: "mc-2",
    title:
      "Following the Child's Lead: Developing Adaptive Conversation Skills",
    description: "Learn techniques for meaningful conversations with children",
    instructor: {
      name: "Rebecca Rolland",
      title: "Speech Pathologist and Lecturer, Harvard University",
    },
    start_time: "2026-02-08T11:30:00",
    end_time: "2026-02-08T13:00:00",
    location: "Workshop Room B",
    capacity: 25,
    current_registrations: 0,
    prerequisites: "None",
    materials: "None",
  },
  {
    id: "mc-3",
    title:
      "Documenting learning: Re-building the meaning of child-led investigations",
    description:
      "Connected approaches to documenting children's learning journeys",
    instructor: {
      name: "Conrad Botha & Valentina Caputo",
      title: "Heritage International Xperiential School Pune",
    },
    start_time: "2026-02-08T14:00:00",
    end_time: "2026-02-08T15:30:00",
    location: "Workshop Room C",
    capacity: 30,
    current_registrations: 0,
    prerequisites: "None",
    materials: "Laptop",
  },
  {
    id: "mc-4",
    title:
      "From Responsibility to Responsiveness: Fathers' role in children's development",
    description: "Exploring the evolving role of fathers in early childhood",
    instructor: {
      name: "Rita Chawla Duggan",
      title: "Lecturer, Early Childhood Studies, Bath University",
    },
    start_time: "2026-02-08T14:00:00",
    end_time: "2026-02-08T15:30:00",
    location: "Workshop Room D",
    capacity: 25,
    current_registrations: 0,
    prerequisites: "None",
    materials: "None",
  },
  {
    id: "mc-5",
    title: "Museum in residence – Emotions Lab",
    description: "Interactive exploration of emotions through museum pedagogy",
    instructor: { name: "Dadu Team", title: "Children's Museum of Qatar" },
    start_time: "2026-02-08T11:30:00",
    end_time: "2026-02-08T13:00:00",
    location: "Workshop Room E",
    capacity: 20,
    current_registrations: 0,
    prerequisites: "None",
    materials: "None",
  },
  {
    id: "mc-6",
    title: "Assessment for Learning in the Foundation Years",
    description: "Meaningful, impactful and future-ready assessment strategies",
    instructor: {
      name: "Fiona Carter & Rashmi Dixon",
      title: "Wellington College International",
    },
    start_time: "2026-02-08T11:30:00",
    end_time: "2026-02-08T13:00:00",
    location: "Workshop Room F",
    capacity: 30,
    current_registrations: 0,
    prerequisites: "None",
    materials: "Laptop",
  },
];
